import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ACTIONS from "../../../../redux/action";
import axios from "../../../../shared/axios/axiosProxy";
import {
  COMPANY_TAX_FORM_LABEL,
  COMPANY_TAX_FORM_SUBTITLE,
  getCompanyTaxFormOptions,
  isCompanyTaxForm,
} from "./CompanyTaxForm";
import classes from "./companyCegjelzoTaxForm.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const CompanyCegjelzoTaxForm = ({ onInteractedChange, initialInteracted = false } = {}) => {
  const companyStore = useSelector((state) => state.company_store);
  const dispatch = useDispatch();

  const options = useMemo(() => getCompanyTaxFormOptions(), []);

  // Don't show a pre-selected option, and keep Next disabled, until the user actually
  // picks something on this screen — even if a default taxform is already stored.
  // initialInteracted carries a real earlier pick forward across step revisits
  // (see searchFlow.jsx), without ever trusting a default value as "interacted".
  const [hasInteracted, setHasInteracted] = useState(initialInteracted);

  useEffect(() => {
    onInteractedChange?.(hasInteracted);
  }, [hasInteracted, onInteractedChange]);

  const selectedValue =
    hasInteracted && isCompanyTaxForm(companyStore.taxform)
      ? companyStore.taxform
      : "";

  const syncSearchTaxFields = useCallback((searchID, companytype, taxform) => {
    if (!searchID) {
      return;
    }
    axios
      .patch(
        `/api/search/${searchID}`,
        { companytype, taxform },
        { headers: { "Content-Type": "application/json" } },
      )
      .catch((error) => {
        console.error(
          "Error saving taxform to searchSchema:",
          error.response?.data || error.message,
        );
      });
  }, []);

  const updateTaxForm = useCallback(
    (value) => {
      setHasInteracted(true);
      dispatch(
        ACTIONS.addCompanyInfo({
          id: "taxform",
          data: value,
          stateObject: "company_store",
        }),
      );
      syncSearchTaxFields(companyStore.searchID, companyStore.companytype, value);
    },
    [companyStore.companytype, companyStore.searchID, dispatch, syncSearchTaxFields],
  );

  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>{COMPANY_TAX_FORM_LABEL}</h1>
              <p className={classes.subtitle}>{COMPANY_TAX_FORM_SUBTITLE}</p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {options.map((option) => {
                  const isSelected = selectedValue === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => updateTaxForm(option.value)}
                      aria-pressed={isSelected}
                    >
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.title}</div>
                        <div className={classes.cardSubtitle}>{option.description}</div>
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyCegjelzoTaxForm;
